// Tour step definitions — one modal per page, all centered (no element spotlighting).
// Each step: { step, page, title, intro, bullets[], nextPage?, nextStep?, navigateToArticle?, isLast? }

export const TOUR_STEPS = [
  // ── Dashboard (/app/coach) ──────────────────────────────────────────
  {
    step: 1, page: "/app/coach",
    title: "Welcome to the Coaches Portal 👋",
    intro: "You're in the updated Kingdom Factor coaches portal. Let's take a quick tour so you know exactly where everything is.",
    bullets: [
      "Your stats card shows total, draft, pending review, and published articles at a glance",
      "Click New Article to start a blank draft from scratch",
      "Use the sidebar to switch between Articles, Meetings, and Settings",
    ],
    nextPage: "/app/coach/articles",
    nextStep: 2,
  },

  // ── Articles Index (/app/coach/articles) ────────────────────────────
  {
    step: 2, page: "/app/coach/articles",
    title: "Your Articles",
    intro: "Every article you create or generate from a meeting lives here — drafts, submitted, rejected, and published.",
    bullets: [
      "Use the status cards at the top to filter by Draft, Pending Review, Published, or Rejected",
      "Click any row in the table to open and edit that article",
      "Click New Article to create a fresh blank draft",
    ],
    navigateToArticle: true,
    nextStep: 3,
  },

  // ── Article Editor (/app/coach/articles/:id) ─────────────────────────
  {
    step: 3, page: "/app/coach/articles/:id",
    title: "The Article Editor",
    intro: "This is where you write, refine, and submit your articles.",
    bullets: [
      "Click Edit to start editing — fill in the title, content, and interviewee details",
      "Click the AI button (top right while editing) to open the AI writing assistant — ask it to rewrite sections, improve tone, or expand ideas",
      "Click any paragraph in the editor while the AI panel is open to focus the AI on exactly that section",
      "Switch to the Podcast tab to configure audio generation for this article",
      "When ready, scroll down and click Submit for Review — the Kingdom Factor team reviews and publishes it",
    ],
    nextPage: "/app/coach/meetings",
    nextStep: 4,
  },

  // ── Meetings (/app/coach/meetings) ───────────────────────────────────
  {
    step: 4, page: "/app/coach/meetings",
    title: "Meetings & Recordings",
    intro: "Generate articles directly from your recorded interviews.",
    bullets: [
      "Click Upload Transcript to paste text or upload a .txt, .docx, or .vtt file",
      "Click Start Recording to invite the Kingdom Factor bot to join your Zoom or Google Meet — it records and transcribes automatically",
      "Connect Google Calendar to detect your upcoming interviews without any manual entry",
      "Click any row in the meetings table to see the full timeline and kick off article generation",
    ],
    nextPage: "/app/coach/settings",
    nextStep: 5,
  },

  // ── Settings (/app/coach/settings) ───────────────────────────────────
  {
    step: 5, page: "/app/coach/settings",
    title: "Settings",
    intro: "Configure your defaults so every article sounds like you.",
    bullets: [
      "AI Writing Guidelines — describe your voice, preferred topics, and phrases to avoid. The more detail you add, the better the AI-generated content matches your communication style",
      "Podcast Defaults — set your preferred podcast style and host voice once, and they'll be pre-selected every time you generate an episode",
      "The CRM link in the left sidebar takes you directly to GoHighLevel for managing your contacts and client relationships",
    ],
    isLast: true,
  },
]
